import React from "react";
import { useLocation } from "react-router-dom";
import { observer } from "mobx-react";

import { useRootAppStore } from "@hooks";
import { useFormContext } from "react-hook-form";
import { CheckboxField } from "@components/inputs/desktop";
import { TFormFilter } from "@state/quick-play-store/QuickBetStore";

export const QuickBetSportsMenuCheckBox = observer(
	function QuickBetSportsMenuCheckBox(props: { isWidget?: boolean }) {
		const rootStore = useRootAppStore();
		const location = useLocation();

		const formContext = useFormContext<TFormFilter>();

		formContext.watch("quickBetType");
		if (!props.isWidget) {
			return null;
		}
		if (
			rootStore.quickPlayStore.quickBetStore.menu?.menu
				.nodesBySelectionOrder?.length == 0
		) {
			return null;
		}

		if (location.pathname.includes("live")) {
			if (location.pathname.includes("events/")) {
				return null;
			} else if (formContext.getValues("quickBetType") !== "live") {
				return null;
			}
		} else if (
			!location.pathname.includes("live") &&
			formContext.getValues("quickBetType") == "live"
		) {
			return null;
		}

		return (
			<CheckboxField
				checkboxClassname="form__field input--check"
				labelClassName="input--check__label u-type--sml"
				id="includeMenu"
				name="includeMenu"
				label="QUICK_PLAY.QUICK_BET.MENU_OFFER"
			/>
		);
	}
);
